import React, { Fragment } from "react";
import { DKIcon, DKLabel, DKInput, DKCheckMark, DKTooltipWrapper } from "deskera-ui-library";
import ic_info_message from "../../../assets/icons/ic_info_gray01.png";
import CustomSectionManager from "../../../managers/CustomSectionManager";

function CustomSectionField({ field, updateField }) {
    const onChange = (field, value) => {
		if (field) {
			const fieldToUpdate = {
                ...field,
                ...CustomSectionManager.errorValidation(field, value),
                value: value,
            };

            updateField(fieldToUpdate);
		}
	};

    const renderField = (field) => {
        switch (field.type) {
            case 'checkbox':
                return (
                    <div key={field.id} className={`column web-width-50 p-h-l pb-s mb-s padding-bottom-mobile ${field.id}`}>
                        <div className="row pt-xxl pb-l">
                            <DKCheckMark
                                color="bg-app"
                                isSelected={field.value}
                                disabled={field.readOnly}
                                onClick={() => {
                                    onChange(field, !field.value);
                                }}
                            />
                            <DKLabel className="ml-s" text={field.name} />
                            {field.tooltipText && (
                                <DKTooltipWrapper content={field.tooltipText} tooltipClassName="warning-tooltip-prop ">
                                    <DKIcon src={ic_info_message} className="ml-s ic-s ml-r mt-xs cursor-hand " style={{ opacity: 0.4 }} />
                                </DKTooltipWrapper>
                            )}
                        </div>
                    </div>
                );
            default:
                return (
                    <div
                        key={field.id}
                        className={`column web-width-50 p-h-l pb-s mb-s padding-bottom-mobile ${field.id} ${field.hasError ? 'mb-m' : ''}`}
                    >
                        <DKInput
                            title={field.name}
                            placeholder={field.name}
                            value={field.value}
                            className=""
                            formatter={(option) => {
                                return option?.name || option;
                            }}
                            options={field.options}
                            type={field.type}
                            labelClassName=" text-align-left "
                            onChange={(value) => {
                                onChange(field, value);
                            }}
                            direction={field.direction}
                            required={field.required}
                            readOnly={field.readOnly}
                            canValidate={field.hasError}
                            onClick={() => {}}
                            dropdownConfig={{
                                allowSearch: field.options && field.options.length > 6 ? true : false,
                                searchableKey: 'name',
                                data: field.options,
                                renderer: (index, obj) => {
                                    return <DKLabel text={obj.name} />;
                                },
                                onSelect: (index, value) => {},
                            }}
                            tooltip={{
                                content: field.tooltipText,
                                className: 'warning-tooltip-prop',
                            }}
                            validator={(value) => {
                                return !field.hasError;
                            }}
                            errorMessage={field.errMsg}
                        />
                    </div>
                );
        }
    };

    return (
        <Fragment>
            {field && renderField(field)}
        </Fragment>
    );
}

export default CustomSectionField;
